import React from "react";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import FormControl from "@mui/material/FormControl";

export default function Thongbao() {
  return (
    <GridContainer>
      <GridItem xs={12} sm={10} md={12} style={{ height: "67vh" }}>
        <FormControl
          style={{ width: "100%", marginTop: "13px", height: "100%" }}
        >
          <table style={{ width: "100%", borderTop: "1px solid #4f7edb" }}>
            <thead>
              <tr>
                <th style={{ float: "left" }}>
                  <a style={{ color: "blue" }}>Chưa có thông báo!</a>
                </th>
              </tr>
            </thead>
          </table>
        </FormControl>
      </GridItem>
    </GridContainer>
  );
}
